import React from "react";
import { TextLg, TextMd, TextSm } from "../../../components/text";
import { useAppContext } from "../../../context/appContext";
import { SeeMore } from "../components/seeMore";

export const WebDevelopmentSection = ({
  className = "",
  style = {},
}) => {
  const { routing } = useAppContext();
  const { navigate } = routing;

  return (
    <button
      className={`flex w-full flex-col items-center gap-8 text-left ${className}`}
      style={style}
      onClick={() => {
        navigate("/web-development");
      }}
    >
      <div className="w-full flex flex-col">
        <TextSm className="uppercase whitespace-nowrap tracking-[0.1em] text-blue-500 font-semibold">
          Web Development
        </TextSm>

        <TextMd className="font-semibold text-slate-900 mb-4">
          Turning ideas into production-ready software.
        </TextMd>

        <TextSm className="text-slate-500 leading-7 mb-8">
          I develop modern web applications, automation tools, and
          integrated business systems using technologies like React,
          Node.js, and AWS. My focus is on creating scalable solutions
          that improve efficiency, support growth, and provide a seamless
          experience for users.
        </TextSm>

        <div className="flex flex-wrap gap-x-8 gap-y-3">
          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>Full Stack Applications</TextSm>
          </div>

          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>API Development</TextSm>
          </div>

          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>Cloud Architecture</TextSm>
          </div>
        </div>
      </div>

      <SeeMore />
    </button>
  );
};